import { NgModule, Pipe, PipeTransform } from '@angular/core';

import { MtnaDataType } from '@mtna/data-core-ui';

import { RdsDataTypeUtil } from '../utils/data-type-util';

@Pipe({
  name: 'rdsIsDataTypeNumeric',
})
export class RdsIsDataTypeNumericPipe implements PipeTransform {
  transform(value: MtnaDataType): boolean {
    return RdsDataTypeUtil.isMtnaDataTypeNumeric(value);
  }
}
@NgModule({
  declarations: [RdsIsDataTypeNumericPipe],
  exports: [RdsIsDataTypeNumericPipe],
})
export class RdsIsDataTypeNumericPipeModule {}
